import { Badge } from "@/components/ui/badge";
import { type Fraktion, getFraktionLabel } from "./fraktionen";

export const FraktionBadge = ({ fraktion }: { fraktion?: Fraktion | null }) => {
  if (!fraktion) return null;
  return (
    <Badge variant="outline" className="text-muted-foreground font-normal">
      {getFraktionLabel(fraktion)}
    </Badge>
  );
};
